module.exports = __webpack_public_path__ + "static/img/noonShift.59163a5b.svg";